import React from 'react'
import { TimesheetCorrection } from '../components/Timesheet/TimesheetCorrection'
import { useParams } from 'react-router-dom'
export const TimesheetCorrectionView = () => {
  const {timesheetId} = useParams();
  return (
    <TimesheetCorrection timesheetId={timesheetId} />
  )
}
